import { Button, Divider, Grid, IconButton, InputAdornment, Typography } from '@mui/material';
import { styles } from './styles';
import CustomTooltip from 'components/custom-tooltip';
import OutlinedInput from 'components/inputs/outlined-input';
import SearchIcon from 'assets/icons/buttons/search.svg';
import ListIcon from 'assets/icons/List_view_icon.svg';
import GridIcon from 'assets/icons/Grid_view_icon.svg';
import { FileCabinetTabs, FileCabinetTabsEnum } from '../file-cabinet-tabs/file-cabinet-tabs';
import { SyntheticEvent } from 'react';
import { IDeletedFilesProps } from 'components/file-cabinet-folders/modals/project-file-cabinet-modal/types';

interface IDeletedMainActions {
  noItems: boolean;
  isGrid: boolean;
  searchValue: string;
  deletedFilesProps: IDeletedFilesProps;
  onViewChange: (value: boolean) => void;
  onSearchChange: (value: string) => void;
  openDeleteAllFilesModal: () => void;
}

export const DeletedMainActions = ({
  noItems,
  isGrid,
  searchValue,
  deletedFilesProps,
  onViewChange,
  onSearchChange,
  openDeleteAllFilesModal,
}: IDeletedMainActions) => {
  const { openDeletedFilesFolder, closeDeletedFilesFolder, isDeletedFilesFolderOpen } =
    deletedFilesProps || {};

  const handleChangeTab = (_: SyntheticEvent, newValue: FileCabinetTabsEnum) => {
    newValue === FileCabinetTabsEnum.STORAGE
      ? closeDeletedFilesFolder?.()
      : openDeletedFilesFolder?.();
  };

  return (
    <Grid sx={styles.container}>
      <Grid sx={styles.breadCrumbs}>
        <CustomTooltip title="File Cabinet">
          <Typography onClick={closeDeletedFilesFolder} sx={styles.breadCrumb} className="first">
            Project Storage
          </Typography>
        </CustomTooltip>
        <CustomTooltip title="Deleted Files">
          <Typography sx={styles.breadCrumb} className="last">
            / Deleted Files
          </Typography>
        </CustomTooltip>
      </Grid>

      <Grid sx={styles.actionsContainer}>
        <FileCabinetTabs
          value={isDeletedFilesFolderOpen ? FileCabinetTabsEnum.TRASH : FileCabinetTabsEnum.STORAGE}
          handleChange={handleChangeTab}
        />

        <Divider sx={styles.divider} />

        <Grid sx={styles.searchInputContainer}>
          <OutlinedInput
            disabled={noItems}
            fullWidth
            withoutHelperText
            placeholder="Search"
            onChange={(e) => onSearchChange(e.target.value)}
            value={searchValue}
            startAdornment={
              <InputAdornment position="start" sx={styles.inputAdornment}>
                <SearchIcon />
              </InputAdornment>
            }
            sx={styles.searchInput}
          />
        </Grid>

        <Grid sx={styles.btnsContainer}>
          <Grid sx={styles.viewBtns}>
            <IconButton
              sx={styles.iconBtn}
              className={`left-rounded ${isGrid ? 'active' : ''}`}
              disableRipple
              onClick={() => onViewChange(true)}
            >
              <GridIcon />
            </IconButton>
            <Divider sx={styles.divider} />
            <IconButton
              sx={styles.iconBtn}
              className={!isGrid ? 'active' : ''}
              disableRipple
              onClick={() => onViewChange(false)}
            >
              <ListIcon />
            </IconButton>
          </Grid>

          <Divider sx={styles.divider} />
          <Button
            variant="contained"
            disabled={noItems}
            sx={styles.mainButton}
            onClick={openDeleteAllFilesModal}
          >
            Delete all files
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
